import { Component, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlComponentBase } from '../../core/control-component-base';


export const CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  multi: true,
  useExisting: forwardRef(() => CheckboxEntryComponent),
};

@Component({
  selector: 'CheckBox',
  templateUrl: './checkbox-entry.component.html',
  styleUrls: ['./checkbox-entry.component.scss'],
  providers: [CONTROL_VALUE_ACCESSOR]
})

export class CheckboxEntryComponent extends ControlComponentBase implements ControlValueAccessor, OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {

  }

}
